import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Add = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.55024 3.45454C8.55024 3.15079 8.304 2.90454 8.00024 2.90454C7.69648 2.90454 7.45024 3.15079 7.45024 3.45454V7.45H3.45479C3.15103 7.45 2.90479 7.69624 2.90479 8C2.90479 8.30376 3.15103 8.55 3.45479 8.55H7.45024V12.5455C7.45024 12.8492 7.69648 13.0955 8.00024 13.0955C8.304 13.0955 8.55024 12.8492 8.55024 12.5455V8.55H12.5457C12.8495 8.55 13.0957 8.30376 13.0957 8C13.0957 7.69624 12.8495 7.45 12.5457 7.45H8.55024V3.45454Z"
      />
    </svg>
  )
})

export default Add
